import React from 'react'



const Contact = () => {

  
  
  return (
    <div name="contact" className="w-full h-auto bg-gradient-to-b from-black to-gray-800 p-4 pt-28">
        <div className="flex flex-col p-4 justify-center max-w-screen-lg mx-auto h-full">
            <div className="pb-10 " data-aos="fade-right"  data-aos-duration="1800">
                <h2 className="text-5xl inline border-b-4 border-gray-500 p-2 text-white">Contact</h2>
              <p className="mt-10">
                <a href="tel:+918927307388" className="text-3xl font-semibold text-white  hover:text-red-500 cursor-pointer"> +91 8927307388</a>
                </p>
                <p className="mt-5 text-xl text-gray-400">Submit the from below to get in touch with me</p>
            </div>
            <div className="flex justify-center items-center" data-aos="fade-up"  data-aos-duration="2000">
                <form action="https://formspree.io/f/xoqzvyze" method="POST" autoComplete="off" className="flex flex-col w-full " >
                    <input type="text" name="username"  placeholder="Enter Your Name" className="  placeholder-gray-600 font-bold text-xs sm:text-lg p-2 w-1/2 bg-transparent border-2  sm:px-5 px-3 border-orange-500 rounded-full text-white focus:outline-none"autoComplete="off" required/>
                    <input type="text" name="email"  placeholder="Enter Your Email" className="placeholder-gray-600 font-bold  text-xs sm:text-lg p-2 mt-4 w-2/3 bg-transparent border-2 sm:px-5 px-3 border-white rounded-full focus:outline-none text-white"  autoComplete="off" required/>
                    <input type="number" name="phone"  placeholder="Enter Your PhoneNo" className="placeholder-gray-600 font-bold text-xs sm:text-lg text-white p-2 mt-4 w-4/5 bg-transparent border-2 sm:px-5 px-3 border-green-500 rounded-full  focus:outline-none" autoComplete="off" required/>
                    <textarea name="message" placeholder="Enter Your Message"  rows="10" className="placeholder-gray-600 font-bold text-xs  sm:text-lg p-2 mt-4 w-full bg-transparent rounded-full sm:px-5 px-3 border-b-4  border-blue-500 text-white h-14 sm:h-24 focus:outline-none" 
                    autoComplete="off" ></textarea>

                    <button type="submit" className="text-white bg-gradient-to-b from-cyan-500 to-blue-500 px-6 py-3 my-10 mx-auto flex  items-end rounded-md hover:scale-110 duration-300">Let's talk</button>

                </form>
            </div>
            </div>
    </div>
  )
}

export default Contact;